module.exports = new __parcel__URL__("look-whos-back.d88f353d.jpg").toString();